<template>
  <v-card :height="height" color="transparent" class="text-center">
    <!-- ROW CONTROLS -->
    <v-toolbar color="transparent" flat>
      <v-tooltip v-if="density.alert" top>
        <template v-slot:activator="{ on, attrs }">
          <v-chip 
            :color="density.alert" 
            v-bind="attrs" 
            v-on="on" 
            label 
            small
            outlined
          >
            <v-icon left small>{{density.alert}}</v-icon>
            {{$t('Page.Grid.density')}}
          </v-chip>
        </template>
        {{ density.msg }}
      </v-tooltip>

      <v-btn v-else dark color="primary" small text @click="$emit('add:object')">
        <v-icon left>addchart</v-icon>
        Ajouter
      </v-btn>
      
      <v-spacer></v-spacer>

      <v-slider
        v-model.number="heightProxy"
        :max="heightRange.max"
        :min="heightRange.min"
        hide-details
        thumb-color="primary"
        thumb-label
        step="10"
        ticks
        inverse-label
      ></v-slider>
      <v-btn dark icon color="error" @click="$emit('delete')">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-toolbar>

    <template v-if="density.cleanable">
      <v-row align="center" :style="'height: ' + (height - 100) + 'px'">
        <v-col>
          <v-card flat color="transparent">
            <v-badge 
              :content="'x' + objects.length" overlap 
              :color="density.alert" 
              offset-x="40" 
              offset-y="40"
            >
              <v-icon size="100">insert_chart</v-icon>
            </v-badge>
            <v-card-actions>
            <v-btn @click="$emit('clean')" class="mx-auto" text>
              <v-icon left>cleaning_services</v-icon>
              {{ $t('Global.Action.clean') }}
            </v-btn>
          </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </template>
    
    <template v-else>
      <v-scale-transition 
        group 
        class="row align-center" 
        :style="'height: ' + (height - 100) + 'px'" 
        hide-on-leave
        leave-absolute
        origin="top left"
      >
        <v-col v-for="(object, indexObj) in objects" :key="'obj_' + indexObj">
          <v-card flat color="transparent">
            <template v-if="height >= 220">
              <v-icon :size="100">insert_chart</v-icon>
              <v-card-actions>
                <v-btn @click="$emit('remove:object', indexObj)" text class="mx-auto">
                  {{ $t('Global.Action.remove') }}
                </v-btn>
              </v-card-actions>
            </template>
            <template v-else>
              <v-btn @click="$emit('remove:object', indexObj)" text class="mx-auto">
                <v-icon left>insert_chart</v-icon>
                {{ $t('Global.Action.remove') }}
              </v-btn>
            </template>
          </v-card>
        </v-col>
      </v-scale-transition>
    </template>
  </v-card>
</template>

<script>
import { 
  MIN_ROW_HEIGHT, 
  MAX_ROW_HEIGHT, 
  DENSITY_WARNING_LEVEL, 
  DENSITY_ERROR_LEVEL 
} from '@/config/page'

export default {
  name: 'PageLayoutEditorRow',
  props: {
    objects: {type: Array, required: true},
    height: {type: Number, required: true},
    size: {type: Number, required: true}
  },
  computed: {
    heightProxy: {
      get () {
        return this.height
      },
      set (value) {
        this.$emit('update:height', value)
      }
    },
    heightRange () {
      return {
        min: MIN_ROW_HEIGHT,
        max: MAX_ROW_HEIGHT
      }
    },
    density () {
      const densityObject = {
        value: this.objects.length / this.size,
        alert: null,
        msg: null,
        cleanable: false
      }

      if (densityObject.value >= DENSITY_ERROR_LEVEL) {
        densityObject.alert = 'error'
        densityObject.msg = this.$t('Page.Grid.veryHighDensity')
        densityObject.cleanable = true
      } else if (densityObject.value >= DENSITY_WARNING_LEVEL) {
        densityObject.alert = 'warning'
        densityObject.msg = this.$t('Page.Grid.highDensity')
      }

      return densityObject
    }
  }
}
</script>